import { render, staticRenderFns } from "./SentenceDictationType1Form.vue?vue&type=template&id=cc3533e8&"
import script from "./SentenceDictationType1Form.vue?vue&type=script&lang=js&"
export * from "./SentenceDictationType1Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports